import React from "react";
import { Box, Container } from "@mui/system";
import { List, ListItem, Typography } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle } from "@fortawesome/pro-solid-svg-icons";

export default function Layout2Section3({ acf }) {
  return (
    <Box
      sx={{
        position: "relative",
        zIndex: "-1",
      }}
    >
      <Container
        maxWidth="xl"
        sx={{
          height: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-start",
          alignItems: "flex-start",
          color: "#fff",
          transform: "translateZ(1px)",
          background: acf?.background_color ? acf.background_color : "#dddddd",
          pt: 10,
          pb: 10,
        }}
      >
        <Box
          sx={{
            width: {
              xs: "100%",
            },
          }}
        >
          {acf?.intro_text && acf?.intro_text !== "" ? (
            <Typography
              variant="p"
              component="p"
              sx={{
                textAlign: "left",
                mb: 2,
                fontSize: "1.35rem",
              }}
            >
              {acf.intro_text}
            </Typography>
          ) : null}

          {acf?.heading && acf?.heading !== "" ? (
            <Typography
              variant="h2"
              component="h2"
              sx={{
                textAlign: "left",
                fontWeight: 600,
                mb: 2,
              }}
            >
              {acf.heading}
            </Typography>
          ) : null}

          {acf?.description && acf?.description !== "" ? (
            <Typography
              variant="p"
              component="p"
              sx={{
                // fontSize: "1.2rem",
                fontWeight: 500,
              }}
            >
              {acf.description}
            </Typography>
          ) : null}

          {acf?.bullet_points && acf?.bullet_points.length > 0 ? (
            <List
              sx={{
                width: "100%",
                marginTop: "20px",
              }}
            >
              {acf.bullet_points.map((bullet_point, index) => (
                <ListItem
                  key={index}
                  sx={{
                    display: "flex",
                    pl: 0,
                    "&:before": {
                      display: "none",
                    },
                  }}
                >
                  <FontAwesomeIcon
                    icon={faCheckCircle}
                    size="xl"
                    style={{
                      color: "#fff",
                      marginRight: "10px",
                    }}
                  />
                  <Typography key={index}>
                    {bullet_point.bullet_point}
                  </Typography>
                </ListItem>
              ))}
            </List>
          ) : null}
        </Box>
      </Container>
    </Box>
  );
}
